export default {
  AF: {
    'it-IT': 'Afghanistan',
    'en-GB': 'Afghanistan',
  },
  AX: {
    'it-IT': 'Isole Åland',
    'en-GB': 'Åland Islands',
  },
  AL: {
    'it-IT': 'Albania',
    'en-GB': 'Albania',
  },
  DZ: {
    'it-IT': 'Algeria',
    'en-GB': 'Algeria',
  },
  AS: {
    'it-IT': 'Samoa americane',
    'en-GB': 'American Samoa',
  },
  AD: {
    'it-IT': 'Andorra',
    'en-GB': 'Andorra',
  },
  AO: {
    'it-IT': 'Angola',
    'en-GB': 'Angola',
  },
  AI: {
    'it-IT': 'Anguilla',
    'en-GB': 'Anguilla',
  },
  AQ: {
    'it-IT': 'Antartide',
    'en-GB': 'Antarctica',
  },
  AG: {
    'it-IT': 'Antigua e Barbuda',
    'en-GB': 'Antigua & Barbuda',
  },
  AR: {
    'it-IT': 'Argentina',
    'en-GB': 'Argentina',
  },
  AM: {
    'it-IT': 'Armenia',
    'en-GB': 'Armenia',
  },
  AW: {
    'it-IT': 'Aruba',
    'en-GB': 'Aruba',
  },
  AC: {
    'it-IT': 'Isola Ascensione',
    'en-GB': 'Ascension Island',
  },
  AU: {
    'it-IT': 'Australia',
    'en-GB': 'Australia',
  },
  AT: {
    'it-IT': 'Austria',
    'en-GB': 'Austria',
  },
  AZ: {
    'it-IT': 'Azerbaigian',
    'en-GB': 'Azerbaijan',
  },
  BS: {
    'it-IT': 'Bahamas',
    'en-GB': 'Bahamas',
  },
  BH: {
    'it-IT': 'Bahrein',
    'en-GB': 'Bahrain',
  },
  BD: {
    'it-IT': 'Bangladesh',
    'en-GB': 'Bangladesh',
  },
  BB: {
    'it-IT': 'Barbados',
    'en-GB': 'Barbados',
  },
  BY: {
    'it-IT': 'Bielorussia',
    'en-GB': 'Belarus',
  },
  BE: {
    'it-IT': 'Belgio',
    'en-GB': 'Belgium',
  },
  BZ: {
    'it-IT': 'Belize',
    'en-GB': 'Belize',
  },
  BJ: {
    'it-IT': 'Benin',
    'en-GB': 'Benin',
  },
  BM: {
    'it-IT': 'Bermuda',
    'en-GB': 'Bermuda',
  },
  BT: {
    'it-IT': 'Bhutan',
    'en-GB': 'Bhutan',
  },
  BO: {
    'it-IT': 'Bolivia',
    'en-GB': 'Bolivia',
  },
  BA: {
    'it-IT': 'Bosnia ed Erzegovina',
    'en-GB': 'Bosnia & Herzegovina',
  },
  BW: {
    'it-IT': 'Botswana',
    'en-GB': 'Botswana',
  },
  BR: {
    'it-IT': 'Brasile',
    'en-GB': 'Brazil',
  },
  BV: {
    'it-IT': 'Isola Buovet',
    'en-GB': 'Bouvet Island',
  },
  IO: {
    'it-IT': 'Territorio britannico dell’Oceano Indiano',
    'en-GB': 'British Indian Ocean Territory',
  },
  VG: {
    'it-IT': 'Isole Vergini Britanniche',
    'en-GB': 'British Virgin Islands',
  },
  BN: {
    'it-IT': 'Brunei',
    'en-GB': 'Brunei',
  },
  BG: {
    'it-IT': 'Bulgaria',
    'en-GB': 'Bulgaria',
  },
  BF: {
    'it-IT': 'Burkina Faso',
    'en-GB': 'Burkina Faso',
  },
  BI: {
    'it-IT': 'Burundi',
    'en-GB': 'Burundi',
  },
  KH: {
    'it-IT': 'Cambogia',
    'en-GB': 'Cambodia',
  },
  CM: {
    'it-IT': 'Camerun',
    'en-GB': 'Cameroon',
  },
  CA: {
    'it-IT': 'Canada',
    'en-GB': 'Canada',
  },
  IC: {
    'it-IT': 'Isole Canarie',
    'en-GB': 'Canary Islands',
  },
  CV: {
    'it-IT': 'Capo Verde',
    'en-GB': 'Cape Verde',
  },
  BQ: {
    'it-IT': 'Caraibi olandesi',
    'en-GB': 'Caribbean Netherlands',
  },
  KY: {
    'it-IT': 'Isole Cayman',
    'en-GB': 'Cayman Islands',
  },
  CF: {
    'it-IT': 'Repubblica Centrafricana',
    'en-GB': 'Central African Republic',
  },
  EA: {
    'it-IT': 'Ceuta e Melilla',
    'en-GB': 'Ceuta & Melilla',
  },
  TD: {
    'it-IT': 'Ciad',
    'en-GB': 'Chad',
  },
  CL: {
    'it-IT': 'Cile',
    'en-GB': 'Chile',
  },
  CN: {
    'it-IT': 'Cina',
    'en-GB': 'China',
  },
  CX: {
    'it-IT': 'Isola Christmas',
    'en-GB': 'Christmas Island',
  },
  CC: {
    'it-IT': 'Isole Cocos (Keeling)',
    'en-GB': 'Cocos (Keeling) Islands',
  },
  CO: {
    'it-IT': 'Colombia',
    'en-GB': 'Colombia',
  },
  KM: {
    'it-IT': 'Comore',
    'en-GB': 'Comoros',
  },
  CG: {
    'it-IT': 'Congo-Brazzaville',
    'en-GB': 'Congo - Brazzaville',
  },
  CD: {
    'it-IT': 'Congo - Kinshasa',
    'en-GB': 'Congo - Kinshasa',
  },
  CK: {
    'it-IT': 'Isole Cook',
    'en-GB': 'Cook Islands',
  },
  CR: {
    'it-IT': 'Costa Rica',
    'en-GB': 'Costa Rica',
  },
  CI: {
    'it-IT': 'Costa d’Avorio',
    'en-GB': 'Côte d’Ivoire',
  },
  HR: {
    'it-IT': 'Croazia',
    'en-GB': 'Croatia',
  },
  CU: {
    'it-IT': 'Cuba',
    'en-GB': 'Cuba',
  },
  CW: {
    'it-IT': 'Curaçao',
    'en-GB': 'Curaçao',
  },
  CY: {
    'it-IT': 'Cipro',
    'en-GB': 'Cyprus',
  },
  CZ: {
    'it-IT': 'Cechia',
    'en-GB': 'Czechia',
  },
  DK: {
    'it-IT': 'Danimarca',
    'en-GB': 'Denmark',
  },
  DG: {
    'it-IT': 'Diego Garcia',
    'en-GB': 'Diego Garcia',
  },
  DJ: {
    'it-IT': 'Gibuti',
    'en-GB': 'Djibouti',
  },
  DM: {
    'it-IT': 'Dominica',
    'en-GB': 'Dominica',
  },
  DO: {
    'it-IT': 'Repubblica Dominicana',
    'en-GB': 'Dominican Republic',
  },
  EC: {
    'it-IT': 'Ecuador',
    'en-GB': 'Ecuador',
  },
  EG: {
    'it-IT': 'Egitto',
    'en-GB': 'Egypt',
  },
  SV: {
    'it-IT': 'El Salvador',
    'en-GB': 'El Salvador',
  },
  GQ: {
    'it-IT': 'Guinea Equatoriale',
    'en-GB': 'Equatorial Guinea',
  },
  ER: {
    'it-IT': 'Eritrea',
    'en-GB': 'Eritrea',
  },
  EE: {
    'it-IT': 'Estonia',
    'en-GB': 'Estonia',
  },
  SZ: {
    'it-IT': 'Swaziland',
    'en-GB': 'Eswatini',
  },
  ET: {
    'it-IT': 'Etiopia',
    'en-GB': 'Ethiopia',
  },
  FK: {
    'it-IT': 'Isole Falkland',
    'en-GB': 'Falkland Islands',
  },
  FO: {
    'it-IT': 'Isole Fær Øer',
    'en-GB': 'Faroe Islands',
  },
  FJ: {
    'it-IT': 'Figi',
    'en-GB': 'Fiji',
  },
  FI: {
    'it-IT': 'Finlandia',
    'en-GB': 'Finland',
  },
  FR: {
    'it-IT': 'Francia',
    'en-GB': 'France',
  },
  GF: {
    'it-IT': 'Guyana francese',
    'en-GB': 'French Guiana',
  },
  PF: {
    'it-IT': 'Polinesia francese',
    'en-GB': 'French Polynesia',
  },
  TF: {
    'it-IT': 'Terre australi francesi',
    'en-GB': 'French Southern Territories',
  },
  GA: {
    'it-IT': 'Gabon',
    'en-GB': 'Gabon',
  },
  GM: {
    'it-IT': 'Gambia',
    'en-GB': 'Gambia',
  },
  GE: {
    'it-IT': 'Georgia',
    'en-GB': 'Georgia',
  },
  DE: {
    'it-IT': 'Germania',
    'en-GB': 'Germany',
  },
  GH: {
    'it-IT': 'Ghana',
    'en-GB': 'Ghana',
  },
  GI: {
    'it-IT': 'Gibilterra',
    'en-GB': 'Gibraltar',
  },
  GR: {
    'it-IT': 'Grecia',
    'en-GB': 'Greece',
  },
  GL: {
    'it-IT': 'Groenlandia',
    'en-GB': 'Greenland',
  },
  GD: {
    'it-IT': 'Grenada',
    'en-GB': 'Grenada',
  },
  GP: {
    'it-IT': 'Guadalupa',
    'en-GB': 'Guadeloupe',
  },
  GU: {
    'it-IT': 'Guam',
    'en-GB': 'Guam',
  },
  GT: {
    'it-IT': 'Guatemala',
    'en-GB': 'Guatemala',
  },
  GG: {
    'it-IT': 'Guernsey',
    'en-GB': 'Guernsey',
  },
  GN: {
    'it-IT': 'Guinea',
    'en-GB': 'Guinea',
  },
  GW: {
    'it-IT': 'Guinea-Bissau',
    'en-GB': 'Guinea-Bissau',
  },
  GY: {
    'it-IT': 'Guyana',
    'en-GB': 'Guyana',
  },
  HT: {
    'it-IT': 'Haiti',
    'en-GB': 'Haiti',
  },
  HN: {
    'it-IT': 'Honduras',
    'en-GB': 'Honduras',
  },
  HK: {
    'it-IT': 'RAS di Hong Kong',
    'en-GB': 'Hong Kong SAR China',
  },
  HU: {
    'it-IT': 'Ungheria',
    'en-GB': 'Hungary',
  },
  IS: {
    'it-IT': 'Islanda',
    'en-GB': 'Iceland',
  },
  IN: {
    'it-IT': 'India',
    'en-GB': 'India',
  },
  ID: {
    'it-IT': 'Indonesia',
    'en-GB': 'Indonesia',
  },
  IR: {
    'it-IT': 'Iran',
    'en-GB': 'Iran',
  },
  IQ: {
    'it-IT': 'Iraq',
    'en-GB': 'Iraq',
  },
  IE: {
    'it-IT': 'Irlanda',
    'en-GB': 'Ireland',
  },
  IM: {
    'it-IT': 'Isola di Man',
    'en-GB': 'Isle of Man',
  },
  IL: {
    'it-IT': 'Israele',
    'en-GB': 'Israel',
  },
  IT: {
    'it-IT': 'Italia',
    'en-GB': 'Italy',
  },
  JM: {
    'it-IT': 'Giamaica',
    'en-GB': 'Jamaica',
  },
  JP: {
    'it-IT': 'Giappone',
    'en-GB': 'Japan',
  },
  JE: {
    'it-IT': 'Jersey',
    'en-GB': 'Jersey',
  },
  JO: {
    'it-IT': 'Giordania',
    'en-GB': 'Jordan',
  },
  KZ: {
    'it-IT': 'Kazakistan',
    'en-GB': 'Kazakhstan',
  },
  KE: {
    'it-IT': 'Kenya',
    'en-GB': 'Kenya',
  },
  KI: {
    'it-IT': 'Kiribati',
    'en-GB': 'Kiribati',
  },
  XK: {
    'it-IT': 'Kosovo',
    'en-GB': 'Kosovo',
  },
  KW: {
    'it-IT': 'Kuwait',
    'en-GB': 'Kuwait',
  },
  KG: {
    'it-IT': 'Kirghizistan',
    'en-GB': 'Kyrgyzstan',
  },
  LA: {
    'it-IT': 'Laos',
    'en-GB': 'Laos',
  },
  LV: {
    'it-IT': 'Lettonia',
    'en-GB': 'Latvia',
  },
  LB: {
    'it-IT': 'Libano',
    'en-GB': 'Lebanon',
  },
  LS: {
    'it-IT': 'Lesotho',
    'en-GB': 'Lesotho',
  },
  LR: {
    'it-IT': 'Liberia',
    'en-GB': 'Liberia',
  },
  LY: {
    'it-IT': 'Libia',
    'en-GB': 'Libya',
  },
  LI: {
    'it-IT': 'Liechtenstein',
    'en-GB': 'Liechtenstein',
  },
  LT: {
    'it-IT': 'Lituania',
    'en-GB': 'Lithuania',
  },
  LU: {
    'it-IT': 'Lussemburgo',
    'en-GB': 'Luxembourg',
  },
  MO: {
    'it-IT': 'RAS di Macao',
    'en-GB': 'Macao SAR China',
  },
  MG: {
    'it-IT': 'Madagascar',
    'en-GB': 'Madagascar',
  },
  MW: {
    'it-IT': 'Malawi',
    'en-GB': 'Malawi',
  },
  MY: {
    'it-IT': 'Malaysia',
    'en-GB': 'Malaysia',
  },
  MV: {
    'it-IT': 'Maldive',
    'en-GB': 'Maldives',
  },
  ML: {
    'it-IT': 'Mali',
    'en-GB': 'Mali',
  },
  MT: {
    'it-IT': 'Malta',
    'en-GB': 'Malta',
  },
  MH: {
    'it-IT': 'Isole Marshall',
    'en-GB': 'Marshall Islands',
  },
  MQ: {
    'it-IT': 'Martinica',
    'en-GB': 'Martinique',
  },
  MR: {
    'it-IT': 'Mauritania',
    'en-GB': 'Mauritania',
  },
  MU: {
    'it-IT': 'Mauritius',
    'en-GB': 'Mauritius',
  },
  YT: {
    'it-IT': 'Mayotte',
    'en-GB': 'Mayotte',
  },
  MX: {
    'it-IT': 'Messico',
    'en-GB': 'Mexico',
  },
  FM: {
    'it-IT': 'Micronesia',
    'en-GB': 'Micronesia',
  },
  MD: {
    'it-IT': 'Moldavia',
    'en-GB': 'Moldova',
  },
  MC: {
    'it-IT': 'Monaco',
    'en-GB': 'Monaco',
  },
  MN: {
    'it-IT': 'Mongolia',
    'en-GB': 'Mongolia',
  },
  ME: {
    'it-IT': 'Montenegro',
    'en-GB': 'Montenegro',
  },
  MS: {
    'it-IT': 'Montserrat',
    'en-GB': 'Montserrat',
  },
  MA: {
    'it-IT': 'Marocco',
    'en-GB': 'Morocco',
  },
  MZ: {
    'it-IT': 'Mozambico',
    'en-GB': 'Mozambique',
  },
  MM: {
    'it-IT': 'Myanmar (Birmania)',
    'en-GB': 'Myanmar (Burma)',
  },
  NA: {
    'it-IT': 'Namibia',
    'en-GB': 'Namibia',
  },
  NR: {
    'it-IT': 'Nauru',
    'en-GB': 'Nauru',
  },
  NP: {
    'it-IT': 'Nepal',
    'en-GB': 'Nepal',
  },
  NL: {
    'it-IT': 'Paesi Bassi',
    'en-GB': 'Netherlands',
  },
  NC: {
    'it-IT': 'Nuova Caledonia',
    'en-GB': 'New Caledonia',
  },
  NZ: {
    'it-IT': 'Nuova Zelanda',
    'en-GB': 'New Zealand',
  },
  NI: {
    'it-IT': 'Nicaragua',
    'en-GB': 'Nicaragua',
  },
  NE: {
    'it-IT': 'Niger',
    'en-GB': 'Niger',
  },
  NG: {
    'it-IT': 'Nigeria',
    'en-GB': 'Nigeria',
  },
  NU: {
    'it-IT': 'Niue',
    'en-GB': 'Niue',
  },
  NF: {
    'it-IT': 'Isola Norfolk',
    'en-GB': 'Norfolk Island',
  },
  KP: {
    'it-IT': 'Corea del Nord',
    'en-GB': 'North Korea',
  },
  MK: {
    'it-IT': 'Macedonia del Nord',
    'en-GB': 'North Macedonia',
  },
  MP: {
    'it-IT': 'Isole Marianne settentrionali',
    'en-GB': 'Northern Mariana Islands',
  },
  NO: {
    'it-IT': 'Norvegia',
    'en-GB': 'Norway',
  },
  OM: {
    'it-IT': 'Oman',
    'en-GB': 'Oman',
  },
  PK: {
    'it-IT': 'Pakistan',
    'en-GB': 'Pakistan',
  },
  PW: {
    'it-IT': 'Palau',
    'en-GB': 'Palau',
  },
  PS: {
    'it-IT': 'Territori palestinesi',
    'en-GB': 'Palestinian Territories',
  },
  PA: {
    'it-IT': 'Panamá',
    'en-GB': 'Panama',
  },
  PG: {
    'it-IT': 'Papua Nuova Guinea',
    'en-GB': 'Papua New Guinea',
  },
  PY: {
    'it-IT': 'Paraguay',
    'en-GB': 'Paraguay',
  },
  PE: {
    'it-IT': 'Perù',
    'en-GB': 'Peru',
  },
  PH: {
    'it-IT': 'Filippine',
    'en-GB': 'Philippines',
  },
  PN: {
    'it-IT': 'Isole Pitcairn',
    'en-GB': 'Pitcairn Islands',
  },
  PL: {
    'it-IT': 'Polonia',
    'en-GB': 'Poland',
  },
  PT: {
    'it-IT': 'Portogallo',
    'en-GB': 'Portugal',
  },
  PR: {
    'it-IT': 'Portorico',
    'en-GB': 'Puerto Rico',
  },
  QA: {
    'it-IT': 'Qatar',
    'en-GB': 'Qatar',
  },
  RE: {
    'it-IT': 'Riunione',
    'en-GB': 'Réunion',
  },
  RO: {
    'it-IT': 'Romania',
    'en-GB': 'Romania',
  },
  RU: {
    'it-IT': 'Russia',
    'en-GB': 'Russia',
  },
  RW: {
    'it-IT': 'Ruanda',
    'en-GB': 'Rwanda',
  },
  WS: {
    'it-IT': 'Samoa',
    'en-GB': 'Samoa',
  },
  SM: {
    'it-IT': 'San Marino',
    'en-GB': 'San Marino',
  },
  ST: {
    'it-IT': 'São Tomé e Príncipe',
    'en-GB': 'São Tomé & Príncipe',
  },
  SA: {
    'it-IT': 'Arabia Saudita',
    'en-GB': 'Saudi Arabia',
  },
  SN: {
    'it-IT': 'Senegal',
    'en-GB': 'Senegal',
  },
  RS: {
    'it-IT': 'Serbia',
    'en-GB': 'Serbia',
  },
  SC: {
    'it-IT': 'Seychelles',
    'en-GB': 'Seychelles',
  },
  SL: {
    'it-IT': 'Sierra Leone',
    'en-GB': 'Sierra Leone',
  },
  SG: {
    'it-IT': 'Singapore',
    'en-GB': 'Singapore',
  },
  SX: {
    'it-IT': 'Sint Maarten',
    'en-GB': 'Sint Maarten',
  },
  SK: {
    'it-IT': 'Slovacchia',
    'en-GB': 'Slovakia',
  },
  SI: {
    'it-IT': 'Slovenia',
    'en-GB': 'Slovenia',
  },
  SB: {
    'it-IT': 'Isole Salomone',
    'en-GB': 'Solomon Islands',
  },
  SO: {
    'it-IT': 'Somalia',
    'en-GB': 'Somalia',
  },
  ZA: {
    'it-IT': 'Sudafrica',
    'en-GB': 'South Africa',
  },
  GS: {
    'it-IT': 'Georgia del Sud e Sandwich australi',
    'en-GB': 'South Georgia & South Sandwich Islands',
  },
  KR: {
    'it-IT': 'Corea del Sud',
    'en-GB': 'South Korea',
  },
  SS: {
    'it-IT': 'Sud Sudan',
    'en-GB': 'South Sudan',
  },
  ES: {
    'it-IT': 'Spagna',
    'en-GB': 'Spain',
  },
  LK: {
    'it-IT': 'Sri Lanka',
    'en-GB': 'Sri Lanka',
  },
  BL: {
    'it-IT': 'Saint-Barthélemy',
    'en-GB': 'St Barthélemy',
  },
  SH: {
    'it-IT': 'Sant’Elena',
    'en-GB': 'St Helena',
  },
  KN: {
    'it-IT': 'Saint Kitts e Nevis',
    'en-GB': 'St Kitts & Nevis',
  },
  LC: {
    'it-IT': 'Saint Lucia',
    'en-GB': 'St Lucia',
  },
  MF: {
    'it-IT': 'Saint Martin',
    'en-GB': 'St Martin',
  },
  PM: {
    'it-IT': 'Saint-Pierre e Miquelon',
    'en-GB': 'St Pierre & Miquelon',
  },
  VC: {
    'it-IT': 'Saint Vincent e Grenadine',
    'en-GB': 'St Vincent & Grenadines',
  },
  SD: {
    'it-IT': 'Sudan',
    'en-GB': 'Sudan',
  },
  SR: {
    'it-IT': 'Suriname',
    'en-GB': 'Suriname',
  },
  SJ: {
    'it-IT': 'Svalbard e Jan Mayen',
    'en-GB': 'Svalbard & Jan Mayen',
  },
  SE: {
    'it-IT': 'Svezia',
    'en-GB': 'Sweden',
  },
  CH: {
    'it-IT': 'Svizzera',
    'en-GB': 'Switzerland',
  },
  SY: {
    'it-IT': 'Siria',
    'en-GB': 'Syria',
  },
  TW: {
    'it-IT': 'Taiwan',
    'en-GB': 'Taiwan',
  },
  TJ: {
    'it-IT': 'Tagikistan',
    'en-GB': 'Tajikistan',
  },
  TZ: {
    'it-IT': 'Tanzania',
    'en-GB': 'Tanzania',
  },
  TH: {
    'it-IT': 'Thailandia',
    'en-GB': 'Thailand',
  },
  TL: {
    'it-IT': 'Timor Est',
    'en-GB': 'Timor-Leste',
  },
  TG: {
    'it-IT': 'Togo',
    'en-GB': 'Togo',
  },
  TK: {
    'it-IT': 'Tokelau',
    'en-GB': 'Tokelau',
  },
  TO: {
    'it-IT': 'Tonga',
    'en-GB': 'Tonga',
  },
  TT: {
    'it-IT': 'Trinidad e Tobago',
    'en-GB': 'Trinidad & Tobago',
  },
  TA: {
    'it-IT': 'Tristan da Cunha',
    'en-GB': 'Tristan da Cunha',
  },
  TN: {
    'it-IT': 'Tunisia',
    'en-GB': 'Tunisia',
  },
  TR: {
    'it-IT': 'Turchia',
    'en-GB': 'Turkey',
  },
  TM: {
    'it-IT': 'Turkmenistan',
    'en-GB': 'Turkmenistan',
  },
  TC: {
    'it-IT': 'Isole Turks e Caicos',
    'en-GB': 'Turks & Caicos Islands',
  },
  TV: {
    'it-IT': 'Tuvalu',
    'en-GB': 'Tuvalu',
  },
  UG: {
    'it-IT': 'Uganda',
    'en-GB': 'Uganda',
  },
  UA: {
    'it-IT': 'Ucraina',
    'en-GB': 'Ukraine',
  },
  AE: {
    'it-IT': 'Emirati Arabi Uniti',
    'en-GB': 'United Arab Emirates',
  },
  GB: {
    'it-IT': 'Regno Unito',
    'en-GB': 'United Kingdom',
  },
  US: {
    'it-IT': 'Stati Uniti',
    'en-GB': 'United States',
  },
  UY: {
    'it-IT': 'Uruguay',
    'en-GB': 'Uruguay',
  },
  UM: {
    'it-IT': 'Altre isole americane del Pacifico',
    'en-GB': 'US Outlying Islands',
  },
  VI: {
    'it-IT': 'Isole Vergini Americane',
    'en-GB': 'US Virgin Islands',
  },
  UZ: {
    'it-IT': 'Uzbekistan',
    'en-GB': 'Uzbekistan',
  },
  VU: {
    'it-IT': 'Vanuatu',
    'en-GB': 'Vanuatu',
  },
  VA: {
    'it-IT': 'Città del Vaticano',
    'en-GB': 'Vatican City',
  },
  VE: {
    'it-IT': 'Venezuela',
    'en-GB': 'Venezuela',
  },
  VN: {
    'it-IT': 'Vietnam',
    'en-GB': 'Vietnam',
  },
  WF: {
    'it-IT': 'Wallis e Futuna',
    'en-GB': 'Wallis & Futuna',
  },
  EH: {
    'it-IT': 'Sahara occidentale',
    'en-GB': 'Western Sahara',
  },
  YE: {
    'it-IT': 'Yemen',
    'en-GB': 'Yemen',
  },
  ZM: {
    'it-IT': 'Zambia',
    'en-GB': 'Zambia',
  },
  ZW: {
    'it-IT': 'Zimbabwe',
    'en-GB': 'Zimbabwe',
  },
};
